import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Logsheet } from 'src/app/models/logsheet.model';
import { LogsheetService } from 'src/app/services/logsheet/logsheet.service';
import { OverviewService } from "src/app/services/overview/overview.service";
import { UnitService } from 'src/app/services/unit/unit.service';
import { RefreshStateService } from 'src/app/services/refresh-state/refresh-state.service';

interface OverviewRefreshState {
  unitId: number;
  unitName: string;
  logsheets: Logsheet[];
  selectedValues: any;
  searchText: string;
}

@Component({
  standalone: false,
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent implements OnDestroy {
  private readonly refreshStateKey = 'overview';

  constructor(private route: ActivatedRoute,
              private router: Router,
              private logsheetService: LogsheetService,
				  public overviewService: OverviewService,
              private unitService: UnitService,
              private refreshState: RefreshStateService

              ) {}
  	selectedValues = {
		company: {
			companyId: 0,
			companyName: "Company",
		},
		plant: {
			plantId: 0,
			plantName: "Plant",
		}
	}
  activeLink = false
searchText: String = ""
firstRender: boolean = false;

	/**
	 * The form renders as islands on the grey canvas, so it must not sit inside the
	 * outlet's white sheet. The branch list still does.
	 */
	get isFormRoute(): boolean {
		return this.router.url.includes("/forms")
	}
	transferData() {
		this.firstRender = true
		this.router.navigateByUrl("home", {
			state: {
				selectedValues: { ...this.selectedValues },
				firstRender: this.firstRender,
			},
		})
	}
	closeOverview() {
			this.overviewService.resetToHome()
		}
  unit: any;
  logsheets: Logsheet[] = []
  unitName: any;
  ngOnInit(){
    this.overviewService.showOverview();
    const navigationState = history.state;
    const savedState = this.refreshState.load<OverviewRefreshState>(this.refreshStateKey);

    if (navigationState && navigationState[0]?.unitName) {
      this.unit = navigationState[0];
      this.unitName = navigationState[0].unitName;
      this.logsheets = navigationState[0].logsheets || [];
      this.selectedValues.company = navigationState[1]?.company || this.selectedValues.company;
      this.selectedValues.plant = navigationState[1]?.plant || this.selectedValues.plant;
      this.sortLogsheets();
      this.persistRefreshState();
      return;
    }

    const routeUnitId = Number(this.route.snapshot.queryParamMap.get('unitId'));
    if (savedState?.unitId && (!routeUnitId || savedState.unitId === routeUnitId)) {
      this.unitName = savedState.unitName;
      this.logsheets = savedState.logsheets || [];
      this.selectedValues = savedState.selectedValues || this.selectedValues;
      this.searchText = savedState.searchText || '';
      this.sortLogsheets();
      this.refreshOverviewData(savedState.unitId);
      return;
    }

    if (routeUnitId) {
      this.refreshOverviewData(routeUnitId);
      return;
    }

    this.overviewService.resetToHome();
    this.router.navigateByUrl('/home');
  }

  onSearchTextChange(value: string): void {
    this.searchText = value;
    this.persistRefreshState();
  }

  ngOnDestroy(): void {
    this.persistRefreshState();
  }

  private refreshOverviewData(unitId: number): void {
    this.unitService.retrieveUnit(String(unitId)).subscribe({
      next: (unit) => {
        this.unit = unit;
        this.unitName = unit.unitName;
        this.logsheetService.retrieveLogsheetByUnit(unitId).subscribe({
          next: (logsheets) => {
            this.logsheets = logsheets || [];
            this.sortLogsheets();
            this.persistRefreshState();
          },
          error: () => this.persistRefreshState(),
        });
      },
      error: () => {
        if (!this.unitName) {
          this.overviewService.resetToHome();
          this.router.navigateByUrl('/home');
        }
      },
    });
  }

  private sortLogsheets(): void {
      this.logsheets.sort((a, b) => {
        const nameA = a.logSheetName.toUpperCase();
        const nameB = b.logSheetName.toUpperCase();
        if (nameA > nameB) {
          return 1;
        }
        if (nameA < nameB) {
          return -1;
        }
        return 0;
      });
  }

  private persistRefreshState(): void {
    const unitId = Number(this.unit?.unitId || this.route.snapshot.queryParamMap.get('unitId'));
    if (!unitId || !this.unitName) return;

    this.refreshState.save<OverviewRefreshState>(this.refreshStateKey, {
      unitId,
      unitName: this.unitName,
      logsheets: this.logsheets,
      selectedValues: this.selectedValues,
      searchText: this.searchText.toString(),
    });
  }
}
